export const energyRateEndpoints = {
  ELECTRIC_RATES: (orgId: string, projectId: string, params?: { subprojectId?: string; sector?: string }) => {
    const base = `/api/organizations/${orgId}/projects/${projectId}/electric-rates/`;
    if (!params) return base;
    const qs = new URLSearchParams();
    if (params.subprojectId) qs.set('subproject_id', params.subprojectId);
    if (params.sector) qs.set('sector', params.sector);
    const q = qs.toString();
    return q ? `${base}?${q}` : base;
  },

  GAS_RATES: (orgId: string, projectId: string, params?: { subprojectId?: string; sector?: string }) => {
    const base = `/api/organizations/${orgId}/projects/${projectId}/gas-rates/`;
    if (!params) return base;
    const qs = new URLSearchParams();
    if (params.subprojectId) qs.set('subproject_id', params.subprojectId);
    if (params.sector) qs.set('sector', params.sector);
    const q = qs.toString();
    return q ? `${base}?${q}` : base;
  },
};
